export const ACTION_LOG_ACTIONS = {
  ORG: {
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    CREATED_ORG: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} created organization {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    APPROVED_ORG: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} approved organization {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REJECTED_ORG: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} rejected organization {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    DELETED_ORG: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} deleted organization {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    SPAMMED_ORG: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} marked organization {object} as spam
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    EDITED_ORG: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} edited organization {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ADDED_ADMIN: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} added administrator to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ADDED_OWNER: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} added owner to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REMOVED_ADMIN: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} removed administrator from {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    TRANSFERED_OWNERSHIP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} transfered ownership of {object}
      </span>
    ),
    INTEGRATION_PARTNER_ENABLE: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} marked organization {object} as integration partner
      </span>
    ),
    INTEGRATION_PARTNER_DISABLE: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} unmarked organization {object} as integration partner
      </span>
    ),
    ALLOWED_POSTING_WO_APPROVAL: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} allowed organization {object} to post without approval
      </span>
    ),
    DISALLOWED_POSTING_WO_APPROVAL: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} disallowed organization {object} to post without approval
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    CHANGED_ORG_TYPE: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} changed organization type of {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    DEFERRED_NEW_ORG: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} deferred new organization {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    INCLUDED_IN_FEEDS: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} included {object} listings in feeds
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    EXCLUDED_FROM_FEEDS: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} excluded {object} listings from feeds
      </span>
    ),
    ALLOWED_VOLUNTEER_POSTINGS: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} allowed {object} to post volunteer opportunities
      </span>
    ),
    DISALLOWED_VOLUNTEER_POSTINGS: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} disallowed {object} to post volunteer opportunities
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MERGED_ORG: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} merged another organization into {object}
      </span>
    ),
    REVIEWED_FLAGGED_CONTENT: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} reviewed flagged content {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REVIEWED_LATE_PAYMENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} reviewed late payment queue item for {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REVIEWED_OVERPOSTER: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} reviewed overposter queue item for {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ALLOWED_CHECKS: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} allowed {object} to pay by check
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    DISALLOWED_CHECKS: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} disallowed {object} to pay by check
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ALLOWED_JAZZHR: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} allowed {object} to use JazzHR
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    DISALLOWED_JAZZHR: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} disallowed {object} to use JazzHR
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ALLOWED_GREENHOUSE: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} allowed {object} to use Greenhouse
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    DISALLOWED_GREENHOUSE: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} disallowed {object} to use Greenhouse
      </span>
    ),
    ALLOWED_ANONYMOUS_POSTING: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} allowed {object} to post anonymously
      </span>
    ),
    DISALLOWED_ANONYMOUS_POSTING: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} disallowed {object} to post anonymously
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    FROZE_ORG: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} froze {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNFROZE_ORG: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} unfroze {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MIGRATED_ORG: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} migrated the data of {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    GAVE_STAGE_TWO: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} gave grad fairs stage 2 privileges to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ALLOWED_API: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} allowed API access to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    DISALLOWED_API: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} disallowed API access to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ALLOWED_OVERPOST: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} allowed overposting for {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    DISALLOWED_OVERPOST: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} disallowed overposting for {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MEMBERSHIP_ADDED: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} added org membership to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MEMBERSHIP_CANCELLED: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} cancelled org membership of {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MEMBERSHIP_EXPIRED: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} expired org membership of {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ADDED_ORG_CONTACT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} added contact to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REMOVED_ORG_CONTACT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} removed contact from {object}
      </span>
    ),
  },
  USER: {
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    CREATED_USER: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} created user {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    GAVE_OWNER_PRIV: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} gave org owner privileges to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    GAVE_ADMIN_PRIV: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} gave org administrator privileges to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REMOVED_ADMIN_PRIV: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} removed org administrator privileges {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    GAVE_STAFF_PRIV: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} gave staff privileges to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REMOVED_STAFF_PRIV: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} removed staff privileges from {object}
      </span>
    ),
    UPDATED_GENERAL_SETTINGS: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} updated general settings of {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    PUBLISHED_USER_PROFILE: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} published profile of {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    UNPUBLISHED_USER_PROFILE: ({
      user,
      object,
    }: {
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} published profile of {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UPDATED_USER_PROFILE: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} updated user profile of {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UPDATED_EMAIL: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} updated email of {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MARK_EMAIL_VERIFIED: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} marked email address of {object} as verified
      </span>
    ),
    UPDATED_NOTIFICATION_PREFERENCES: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} updated notification preferences of {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MARK_EMAIL_UNVERIFIED: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} marked email address of {object} as unverified
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MARK_RECRUITABLE: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} marked {object} as recruitable
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MARK_NOT_RECRUITABLE: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} marked {object} as not recruitable
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MIGRATED_USER: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} migrated the data of {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    DELETED_USER: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} deleted user {object}
      </span>
    ),
    REVIEWED_FLAGGED_CONTENT: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} reviewed flagged content {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    FROZE_USER: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} froze {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNFROZE_USER: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} unfroze {object}
      </span>
    ),

    ACCEPTED_ORG_ADMIN_REQUEST: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} accepted org admin request for {object}
      </span>
    ),

    REJECTED_ORG_ADMIN_REQUEST: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} rejected org admin request for {object}
      </span>
    ),
  },
  JOB: {
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    CREATED_JOB: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} created {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    EDITED_JOB: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} edited {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    APPROVED_JOB: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} approved job {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REJECTED_JOB: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} rejected job {object}
      </span>
    ),
    DEFERRED_PENDING_LISTING: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} deferred pending listing {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REVIEWED_LISTING: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} reviewed job {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    PUBLISHED_JOB: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} published {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNPUBLISHED_JOB: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} unpublished {object}
      </span>
    ),
    MARKED_JOB_READY_TO_PUBLISH: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} marked {object} as ready to publish
      </span>
    ),
    COMPLETED_CHANGES_REVIEW: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} reviewed changes of {object}
      </span>
    ),
    COMPLETED_UNPAID_JOB_REVIEW: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} reviewed unpaid wording of {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    FROZE_JOB: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} froze {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNFROZE_JOB: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} unfroze {object}
      </span>
    ),
    REVIEWED_FLAGGED_CONTENT: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} reviewed flagged content {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    HID_JOB: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} hid {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNHID_JOB: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} unhid {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ADDED_JOB_ON_INVOICE: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} added {object} on an invoice
      </span>
    ),
    REMOVED_JOB_FROM_INVOICE: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} removed {object} from an invoice
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    DELETED_JOB: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} deleted job {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNDELETED_JOB: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} undeleted job {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MIGRATED_JOB: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} migrated the data of {object}
      </span>
    ),
  },
  INTERNSHIP: {
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    CREATED_INTERNSHIP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} created {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    EDITED_INTERNSHIP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} edited {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    APPROVED_INTERNSHIP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} approved internship {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REJECTED_INTERNSHIP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} rejected internship {object}
      </span>
    ),
    DEFERRED_PENDING_LISTING: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} deferred pending listing {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REVIEWED_LISTING: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} reviewed internship {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    PUBLISHED_INTERNSHIP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} published {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNPUBLISHED_INTERNSHIP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} unpubished {object}
      </span>
    ),
    MARKED_INTERNSHIP_READY_TO_PUBLISH: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} marked {object} as ready to publish
      </span>
    ),
    COMPLETED_CHANGES_REVIEW: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} reviewed changes of {object}
      </span>
    ),
    COMPLETED_UNPAID_JOB_REVIEW: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} reviewed unpaid wording of {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    FROZE_INTERNSHIP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} froze {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNFROZE_INTERNSHIP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} unfroze {object}
      </span>
    ),
    REVIEWED_FLAGGED_CONTENT: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} reviewed flagged content {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    HID_INTERNSHIP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} hid {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNHID_INTERNSHIP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} unhid {object}
      </span>
    ),
    ADDED_INTERNSHIP_ON_INVOICE: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} added {object} on an invoice
      </span>
    ),
    REMOVED_INTERNSHIP_FROM_INVOICE: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} removed {object} from an invoice
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    DELETED_INTERNSHIP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} deleted internship {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNDELETED_INTERNSHIP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} undeleted internship {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MIGRATED_INTERNSHIP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} migrated the data of {object}
      </span>
    ),
  },
  VOLOP: {
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    CREATED_VOLOP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} created {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    EDITED_VOLOP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} edited {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    APPROVED_VOLOP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} approved voluteer opportunity {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REJECTED_VOLOP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} rejected voluteer opportunity {object}
      </span>
    ),
    DEFERRED_PENDING_LISTING: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} deferred pending listing {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REVIEWED_LISTING: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} reviewed voluteer opportunity {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    PUBLISHED_VOLOP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} published {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNPUBLISHED_VOLOP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} unpublished {object}
      </span>
    ),
    MARKED_VOLOP_READY_TO_PUBLISH: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} marked {object} as ready to publish
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    FROZE_VOLOP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} froze {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNFROZE_VOLOP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} unfroze {object}
      </span>
    ),
    REVIEWED_FLAGGED_CONTENT: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} reviewed flagged content {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    HID_VOLOP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} hid {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNHID_VOLOP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} unhid {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    DELETED_VOLOP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} deleted volop {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNDELETED_VOLOP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} undeleted volop {object}
      </span>
    ), // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    RENEWED_VOLOP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} renewed volop {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MIGRATED_VOLOP: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} migrated the data of {object}
      </span>
    ),
  },
  EVENT: {
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    CREATED_EVENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} created {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    EDITED_EVENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} edited {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    APPROVED_EVENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} approved event {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REJECTED_EVENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} rejected event {object}
      </span>
    ),
    DEFERRED_PENDING_LISTING: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} deferred pending listing {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REVIEWED_LISTING: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} reviewed event {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    PUBLISHED_EVENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} published {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNPUBLISHED_EVENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} unpublished {object}
      </span>
    ),
    MARKED_EVENT_READY_TO_PUBLISH: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} marked {object} as ready to publish
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    FROZE_EVENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} froze {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNFROZE_EVENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} unfroze {object}
      </span>
    ),
    REVIEWED_FLAGGED_CONTENT: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} reviewed flagged content {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    HID_EVENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} hid {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNHID_EVENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} unhid {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    DELETED_EVENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} deleted event {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    UNDELETED_EVENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} undeleted event {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MIGRATED_EVENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} migrated the data of {object}
      </span>
    ),
  },
  INVOICE: {
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    CREATED_INVOICE: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} created {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ADDED_JOB_ITEM: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} added job item to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ADDED_INTERNSHIP_ITEM: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} added internship item to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ADDED_CREDIT_PACK_ITEM: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} added credit pack item to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ADDED_GRAD_PROGRAM_ITEM: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} added grad program item to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ADDED_DONATION_ITEM: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} added donation item to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ADDED_FAIR_ITEMS: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} added grad fair items to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    WILL_PAY_BY_CHECK: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} will pay {object} by check
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    APPLIED_PAYMENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} applied a payment to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REVERTED_PAYMENT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} reverted a payment previously applied to {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    PAID_CHECKOUT_BY_CC: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} paid {object} by credit card during checkout
      </span>
    ),

    PAID_CHECKOUT_BY_CC_AND_CREDITS: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} paid {object} by credit card and credits during checkout
      </span>
    ),
    PAID_AFTER_CHECKOUT_BY_CC: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} paid {object} by credit card after checkout
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    USED_CREDITS: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} used credits on {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    VOIDED_ITEM: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} voided items on {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REFUNDED_ITEM: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} refunded items on {object}
      </span>
    ),
    ADDED_ITEMS_FROM_OTHER_INVOICE: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} added items on {object} from another invoice
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REMOVED_ITEM: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} removed an item from {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    MIGRATED_INVOICE: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} migrated the data of {object}
      </span>
    ),
    ALLOWED_PARTIAL_PAYMENTS: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} started accepting partial payments for {object}
      </span>
    ),
    DISALLOWED_PARTIAL_PAYMENTS: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} stopped accepting partial payments for {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    CHANGED_BILLING_ADDRESS: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} changed the billing address of {object}
      </span>
    ),
    CHECKOUT_BY_APPROVING_ORG: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} completed checkout by approving org of {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    CHECKOUT_BY_APPROVAL: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} completed checkout by approval for {object}
      </span>
    ),
    ADDED_LISTING_PROMOTION_ITEM: ({
      user,
      object,
    }: {
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      user: any;
      // TODO: Fix this the next time the file is edited.
      // oxlint-disable-next-line typescript/no-explicit-any
      object: any;
    }) => (
      <span>
        {user} added a listing promotion item for {object}
      </span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    ADDED_MEMBERSHIP_ITEM: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} added a membership item for {object}
      </span>
    ),
  },
  LINE_ITEM: {
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    DELETED_LINE_ITEM: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} removed line item {object} from invoice
      </span>
    ),
  },
  CREDIT: {
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    GAVE_JOB_PROMO_CREDIT: ({ user }: { user: any }) => (
      <span>{user} applied a job promo credit</span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    GAVE_INTERNSHIP_PROMO_CREDIT: ({ user }: { user: any }) => (
      <span>{user} applied an internship promo credit</span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    GAVE_FAIR_PROMO_CREDIT: ({ user }: { user: any }) => (
      <span>{user} applied a fair promo credit</span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REMOVED_JOB_PROMO_CREDIT: ({ user }: { user: any }) => (
      <span>{user} removed a job promo credit</span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REMOVED_INTERNSHIP_PROMO_CREDIT: ({ user }: { user: any }) => (
      <span>{user} removed an internship promo credit</span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    REMOVED_FAIR_PROMO_CREDIT: ({ user }: { user: any }) => (
      <span>{user} removed a fair promo credit</span>
    ),
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    GAVE_MEMBERSHIP_PROMO_CREDIT: ({ user }: { user: any }) => (
      <span>{user} earned a membership promo credit</span>
    ),
  },
  CREDIT_PACK: {
    // TODO: Fix this the next time the file is edited.
    // oxlint-disable-next-line typescript/no-explicit-any
    CANCELLED_CREDIT: ({ user, object }: { user: any; object: any }) => (
      <span>
        {user} cancelled a credit from {object}
      </span>
    ),
  },
  NONE: {},
} as const;
